import {RootState} from '../rootReducer';

export const authExpirationSelector = (state: RootState) => state.authExpiration;
